var charpstarARElement, charpstarARArtNo, charpstarARiOSLink, charpstarARAndroidLink, charpstarQRLang, charpstar3DViewerElement, charpstar3DLink, charpstarViewerArtNo;
charpstarARElement = document.getElementById("charpstarARViewer");
charpstar3DViewerElement = document.getElementById("threeDViewer");

if (charpstarARElement) {
        var href = location.href;
        charpstarARElement.addEventListener('click', activateAR, false);
        charpstarARArtNo = href.match(/([^\/]*)\/*$/)[1];
      //  charpstarARArtNo = "cube-koyeseng-90x200-hvit";
        charpstarARiOSLink = "https://drm.charpstar.net/iOS/" + charpstarARArtNo + ".usdz"
        charpstarARAndroidLink = "https://drm.charpstar.net/Android/" + charpstarARArtNo + ".glb"
        charpstarQRLang = charpstarARElement.getAttribute("data-language");
        checkLink(charpstarARAndroidLink);
}

async function checkLink(url) {
   const response = await fetch(url, {
        method: 'HEAD'
    });
    if (response.ok) {
        if (charpstarARElement){
            charpstarARElement.style.display = "block";
            charpstarARElement.addEventListener('click', activateAR, false);
        }
        if (charpstar3DViewerElement){
            charpstar3DViewerElement.addEventListener('click', toggle3DViewer, false);
            charpstar3DViewerElement.style.display = "block";
        }
        checkForARSupport();
    } 
    else {
        hideARButton();
    }
    await response.text()
}




const openIOSARQuickLook = (() => {
    const anchor = document.createElement('a');
    anchor.setAttribute('rel', 'ar');
    anchor.appendChild(document.createElement('img'));
    anchor.setAttribute("id", "charpstar");
    return (usdzSrc) => {
        anchor.setAttribute('href', usdzSrc);
        anchor.click();
    };
})();

const openSceneViewer = (() => {
    const anchor = document.createElement('a');
    const noArViewerSigil = '#model-viewer-no-ar-fallback';
    let fallbackInvoked = false;
    return (gltfSrc, title, arScale) => {
        // If the fallback has ever been invoked this session, bounce early:
        if (fallbackInvoked) {
            return;
        }
        const location = self.location.toString();
        const locationUrl = new URL(location);
        const modelUrl = new URL(gltfSrc, location);
        const scheme = modelUrl.protocol.replace(':', '');
        locationUrl.hash = noArViewerSigil;
        let intentParams = `?file=${encodeURIComponent(modelUrl.toString())}&mode=ar_preferred&link=${location}&title=${encodeURIComponent(document.title)}`;
        intentParams += `&resizable=false`;
        intentParams += `&disable_occlusion=true`;
        const intent = `intent://arvr.google.com/scene-viewer/1.0?${intentParams.toString() + '&file=' +encodeURIComponent(modelUrl.toString())}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(locationUrl.toString())};end;`;
        const undoHashChange = () => {
            if (self.location.hash === noArViewerSigil && !fallbackInvoked) {
                fallbackInvoked = true;
                self.history.back();
            }
        };
        self.addEventListener('hashchange', undoHashChange, {
            once: true
        });
        anchor.setAttribute('href', intent);
        anchor.click();
    };
})();


function activateAR() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPhone|iPod/.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        openIOSARQuickLook(charpstarARiOSLink);
    } 
    else if (/android/i.test(userAgent)) {
        openSceneViewer(charpstarARAndroidLink);
    }
    else {
        toggleModal();
    }
}

function checkForiOSSupport() {
  
}

function checkForAndroidSupport() {
    showARButton();
    var a = navigator.userAgent;
    if ( a.includes ('wv')) {
          hideARButton();
    } 
}

function checkForARSupport() {
    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
        iOS: function() {
            return navigator.userAgent.match(/iPhone/i);
        },
        iPad: function() {
            return (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        },
        any: function() {
            return (isMobile.Android() || isMobile.iOS() || isMobile.iPad());
        }
    };
    if (!isMobile.any()) {
    if (charpstarARElement.hasAttribute("data-desktopQR")) {
        showARButton();
    }
    } else if (isMobile.Android()) {
        checkForAndroidSupport();
    } else if (isMobile.iOS() || isMobile.iPad()) {
        checkForiOSSupport();
    }
}

function hideARButton() {
    if (charpstarARElement) {
    charpstarARElement.style.display = "none";
    }
     if (charpstar3DViewerElement) {
    charpstar3DViewerElement.style.display = "none";
    }
}

function showARButton() {
    if (charpstarARElement) {
    charpstarARElement.style.display = "block";
    }
    if (charpstar3DViewerElement) {
    charpstar3DViewerElement.style.display = "block";
    }
}


//QR Code Logic 

var QRModalDiv = document.createElement("div");
QRModalDiv.setAttribute('class', 'QRModal');
QRModalDiv.style.zIndex = "15";
QRModalDiv.style.width = "100%";
QRModalDiv.style.height = "100%";
QRModalDiv.style.position = "fixed";
QRModalDiv.style.background = "rgba(0, 0, 0, 0.5)";
QRModalDiv.style.opacity = "1";
QRModalDiv.style.visibility = "visible";
QRModalDiv.style.transform = "scale(1.1)";
QRModalDiv.style.transition = "visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s";
QRModalDiv.style.top = "0";
QRModalDiv.style.left = "0";
var QRModaliframe = document.createElement('iframe');
QRModaliframe.frameborder = "0";
QRModaliframe.height = "585px";
QRModaliframe.width = "404px";
QRModaliframe.style.top = "50%";
QRModaliframe.style.left = "50%";
QRModaliframe.style.position = "absolute";
QRModaliframe.style.transform = "translate(-50%, -50%)";
QRModalDiv.appendChild(QRModaliframe);


var QRCodeModalActive = false, ViewerModalActive = false;

function toggleModal() {
    var variantARCodeCharpstar = charpstarARArtNo;
    var QRCurrentProductAppend = "https://drm.charpstar.net/drm.html?art=" + variantARCodeCharpstar;
    
    if (charpstarQRLang == "sv-se" || charpstarQRLang == "sv") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenSv.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "en-gb" || charpstarQRLang == "en-us") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGen.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "no-no" || charpstarQRLang == "nb-no") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenNO.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "da-dk") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenDK.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "lt-lt") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenLT.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "de-at") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenAT.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "de-de") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenDE.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "lv-lv") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenLV.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "cs-cz") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenCZ.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "pl-pl") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenPL.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "sk-sk") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenSK.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "hr-hr") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenHR.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "et-ee") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenEE.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "fi-fi") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenFI.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else if (charpstarQRLang == "is-is") {
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGenIS.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }
    else { 
    var fullQRSrc = "https://js.charpstar.net/QRLang/QRGen.html?charpstar-ar-href=" + QRCurrentProductAppend;
    }


    QRModaliframe.src = fullQRSrc;
    if (QRCodeModalActive == false) {
        document.body.appendChild(QRModalDiv);
        setTimeout(function() {
            QRCodeModalActive = true;
        }, 200);
    } else {
        document.body.removeChild(QRModalDiv);
        QRCodeModalActive = false;
    }
}

function windowOnClick(event) {
    if (QRCodeModalActive == true) {
        toggleModal();
    }
   if (ViewerModalActive == true) {
        toggle3DViewer();
    }
    
}
window.addEventListener("click", windowOnClick);

function QRCloseButtonEvent(msg) {
    if (msg.data == "CloseQRModal") {
        toggleModal();
    }
}
if (window.addEventListener) {
    window.addEventListener("message", QRCloseButtonEvent, false);
} else {
    window.attachEvent("onmessage", QRCloseButtonEvent);
}

function ViewerCloseButtonEvent(msg) {
    if (msg.data == "CloseViewerModal") {
        toggle3DViewer();
    }
}

if (window.addEventListener) {
    window.addEventListener("message", ViewerCloseButtonEvent, false);
} else {
    window.attachEvent("onmessage", ViewerCloseButtonEvent);
}





function toggle3DViewer(){
    ViewerModaliframe.src = "https://js.charpstar.net/AR/viewer.html?product="+charpstarARAndroidLink;
        if (ViewerModalActive == false) {
        document.body.appendChild(ViewerModalDiv);
        setTimeout(function() {
            ViewerModalActive = true;
        }, 200);
    } else {
        document.body.removeChild(ViewerModalDiv);
        ViewerModalActive = false;
    }
}

var ViewerModalDiv = document.createElement("div");
ViewerModalDiv.setAttribute('class', 'ViewerModal');
ViewerModalDiv.style.zIndex = "100000";
ViewerModalDiv.style.width = "100%";
ViewerModalDiv.style.height = "100%";
ViewerModalDiv.style.position = "fixed";
ViewerModalDiv.style.background = "rgba(0, 0, 0, 0.5)";
ViewerModalDiv.style.opacity = "1";
ViewerModalDiv.style.visibility = "visible";
ViewerModalDiv.style.transform = "scale(1.1)";
ViewerModalDiv.style.transition = "visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s";
ViewerModalDiv.style.top = "0";
ViewerModalDiv.style.left = "0";
var ViewerModaliframe = document.createElement('iframe');
ViewerModaliframe.frameborder = "0";
ViewerModaliframe.height = "80%";
ViewerModaliframe.width = "80%";
ViewerModaliframe.style.background = "white";
ViewerModaliframe.style.top = "50%";
ViewerModaliframe.style.left = "50%";
ViewerModaliframe.style.position = "absolute";
ViewerModaliframe.style.transform = "translate(-50%, -50%)";
ViewerModalDiv.appendChild(ViewerModaliframe);


